export default __webpack_public_path__ + "static/media/dashboard.a9590b2a.svg";